module.exports = __webpack_public_path__ + "static/media/WP-NEW-APP13.1eebd576.jpg";